import { render, staticRenderFns } from "./previewFrame.vue?vue&type=template&id=4cfeb0b9&scoped=true&"
import script from "./previewFrame.vue?vue&type=script&lang=js&"
export * from "./previewFrame.vue?vue&type=script&lang=js&"
import style0 from "./previewFrame.vue?vue&type=style&index=0&id=4cfeb0b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfeb0b9",
  null
  
)

export default component.exports